export default "__VITE_ASSET__qxdg79_T__"